import { Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Company } from '../../interfaces/company';
import { DisclaimerTypes } from '../../interfaces/disclaimertypes';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { CompanyService } from '../../service/company.service';
import { UserdataService } from '../../service/userdata.service';

@Component({
    selector: 'app-register',
    standalone: false,

    templateUrl: './register.component.html',
    styleUrl: './register.component.scss'
})
export class RegisterComponent implements OnInit {
    // Injections
    companyServie = inject(CompanyService);

    @Input() promotionData: any;
    hidespinner: boolean = true;
    registerForm!: FormGroup;
    phone: string = '';
    registrySuccess: boolean = true;
    regError: boolean = false;
    disclaimerType: DisclaimerTypes = DisclaimerTypes.TERMS_CONDITIONS;

    // Variables related to registration and UI state
    companyData: Company | undefined;

    private inviteId: string | null = null;

    constructor(
        private authService: AuthandregistryService,
        private userdata: UserdataService,
        private _fb: FormBuilder
    ) {}

    public async ngOnInit(): Promise<void> {
        const queryParams = new URLSearchParams(window.location.search);

        if (queryParams.has('inviteId')) {
            this.inviteId = queryParams.get('inviteId');

            await this.authService.doLogOut(false);
            await this.loadCompanyDataById(<string>this.inviteId);
        }

        if (!this.promotionData) {
            await this.authService.doAutoLogin();
        }

        this.buildRegisterForm();
    }

    async loadCompanyDataById(id: string): Promise<void> {
        const result = await this.companyServie.getpublicCompanyData(id);

        if (result === false) {
            return;
        }

        this.companyData = result;
    }

    async onSubmit() {
        if (this.registerForm.controls['companyName']) {
            this.registerForm.controls['companyName'].setValue(
                this.registerForm.controls['companyName'].value.trim(),
            );
        }

        const hasCustomForm = this.activeCustomFields.length > 0;

        if (
            this.registerForm.invalid ||
            typeof this.registerForm.value.email !== 'string' ||
            typeof this.registerForm.value.password !== 'string' ||
            (!hasCustomForm && typeof this.registerForm.value.companyName !== 'string') ||
            this.phone != ''
        ) {
            return;
        }

        this.hidespinner = false;

        if (!this.companyData || !this.inviteId) {
            await this.authService.doRegister(
                this.registerForm.value.email,
                this.registerForm.value.password,
                this.registerForm.value.companyName,
                this.promotionData,
            );
        } else {
            const customLoginFormData = this.activeCustomFields
                .filter(f => f.id !== 'email' && f.id !== 'password')
                .map(f => ({ id: f.id, value: this.registerForm.value[f.id] }));

            await this.authService.registerByInviteId(
                this.registerForm.value.email,
                this.registerForm.value.password,
                this.inviteId,
                false,
                undefined,
                this.companyData.invitationProcessType!,
                customLoginFormData.length ? customLoginFormData : undefined,
            );
        }

        this.hidespinner = true;
    }

    protected fieldLabel(id: string): string {
        return id.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase());
    }

    protected get activeCustomFields() {
        return this.companyData?.customLoginFormData?.filter(f => f.active) ?? [];
    }

    private buildRegisterForm(): void {
        if (this.activeCustomFields.length) {
            const controls: Record<string, any> = {};
            for (const field of this.activeCustomFields) {
                controls[field.id] = ['', field.required ? Validators.required : []];
            }
            this.registerForm = this._fb.group(controls);
        } else {
            this.registerForm = this._fb.group({
                email: ['', Validators.required],
                password: ['', Validators.required],
                companyName: [
                    this.companyData ? this.companyData.name : '',
                    Validators.required,
                ],
            });
        }
    }

}
